<template>
  <nav class="navbar has-background-primary-light ">
    <div class="navbar-brand">
      <a class="navbar-item">
	<img class="mylogo"
          width="350" height="100"
	  src="@/assets/logo-text-side.png"
	  >
      </a>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
        @click="burgerClicked">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="navbar-menu" :class="{'is-active': this.burger_active}">
      <div class="navbar-end">
        <div class="navbar-item is-italic">
          {{ displayName() }}
        </div>
        <div class="navbar-item is-italic">
          <router-link to="/settings">Account</router-link>
        </div>
        <div class="navbar-item is-italic" @click="this.logout">
          <router-link to="/login">Sign Out</router-link>
        </div>
      </div>
    </div>
  </nav>
</template>


<script>
import { mapState, mapActions } from 'pinia'
import { login, useLogin  } from '@/js/auth.js'

export default {
    data() {
        return {
            burger_active: false,
        } 
    },
    methods: {
        ...mapActions(useLogin, ["logout", "login"]),
        burgerClicked() {
            console.log("clicked...")
            this.burger_active = !this.burger_active
        },
        displayName(){
            return this.email
        }
    },
    computed: {
        ...mapState(useLogin, ["email", "claims"]),
    },
}
</script>

<style>
img.mylogo {
    min-height: 100px;
    min-width: 350px
}
</style>
